// IntegratedHomeTiles.jsx — 통합 관리 홈 요약 칸 (2026-10-01, 시안대로)
//   운영자 3칸: 통합 메뉴 N개 / 묶인 회사 / 배정 N건(메뉴별 합계 — 같은 사람을 메뉴마다 센다)
//   그 외 2칸: 내 통합 메뉴 N개 / 묶인 회사 (배정 수는 관리 주소라 받지 않는다)
import React from 'react';
import { cn } from '../../../lib/utils';
import CompanyChip from './CompanyChip';

const tileCls = 'min-w-0 rounded-2xl border border-[var(--border)] bg-[var(--bg-card)] px-[18px] py-4 flex flex-col gap-1.5';
const labelCls = 'text-[12px] font-bold text-[var(--text-muted)]';
const numCls = 'text-[26px] font-black leading-tight text-[var(--text)]';
const unitCls = 'ml-1 text-[13px] font-bold text-[var(--text-muted)]';

export default function IntegratedHomeTiles({ summary, isOperator, isMobile }) {
  const hidden = summary.menuCount - summary.sidebarCount;
  return (
    <div className={cn('grid gap-3', isMobile ? 'grid-cols-1' : (isOperator ? 'grid-cols-3' : 'grid-cols-2'))}>
      <div className={tileCls}>
        <span className={labelCls}>{isOperator ? '통합 메뉴' : '내 통합 메뉴'}</span>
        <span className={numCls}>{summary.menuCount}<span className={unitCls}>개</span></span>
        {/* 사이드바·표는 짝 달력을 빼고 센다 — 숫자가 달라 보이는 이유를 적는다 */}
        {hidden > 0 && (
          <span className="text-[11px] text-[var(--text-muted)]">
            사이드바 {summary.sidebarCount}개 · 달력 {hidden}개는 출퇴근 관리 안 [달력] 탭
          </span>
        )}
      </div>
      <div className={tileCls}>
        <span className={labelCls}>묶인 회사</span>
        <span className="flex min-h-[39px] flex-wrap items-center gap-1.5">
          {summary.companyCodes.map((code) => <CompanyChip key={code} code={code} />)}
        </span>
      </div>
      {isOperator && (
        <div className={tileCls}>
          <span className={labelCls}>배정</span>
          <span className={numCls}>{summary.assigneeSum}<span className={unitCls}>건 (메뉴별 합계)</span></span>
        </div>
      )}
    </div>
  );
}
